import React, {FC, useCallback, useEffect} from 'react'
import styles from './TablePixPage.module.scss'
import {Button, Icon} from '@material-ui/core'
import {toast} from 'react-toastify';
import {useTablePayment} from "../../../context/tablePayment/TablePaymentContext";
import {PaymentApi} from "../../../services/Api/payment/PaymentApi";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {useUi} from "../../../context/ui/UIContext";

const TablePixPage: FC = () => {
    const { pixValues, setPixValues, pixTimerRef, onPaymentConcluded } = useTablePayment();
    const { meepPaymentId } = useParams<{ meepPaymentId: string }>();
    const { goBack } = useHistory();
    const { toastFullScreen } = useUi();
    const location = useLocation();

    const verifyPixPayment = useCallback(async () => {
        try {
            const query = new URLSearchParams(location.search);
            const pedidoId = query.get('pedidoId');
            if (!pedidoId) return;
            const response = await PaymentApi().getPixStatus(pedidoId)
            const data = response.data;
            if (!pixValues) {
                setPixValues(data);
            }
            if (data.status === "pending") {
                return;
            }
            if (data.status === "cancelled") {
                toastFullScreen(
                    'A solicitação PIX foi cancelada',
                    "error",
                    "error",
                    30000,
                    () => {
                        if (pixTimerRef.current) {
                            clearInterval(pixTimerRef.current);
                        }
                        goBack()
                    }
                );
                return;
            }
            if (data.status === "approved") {
                onPaymentConcluded(pedidoId, true);
            }
        } catch (error: any) {
            toastFullScreen(
                error?.response?.data?.message ?? 'Não foi possível carregar o PIX',
                "error",
                "error",
                30000,
                 () => goBack()
            );
        }

    }, [goBack, location.search, onPaymentConcluded, pixTimerRef, pixValues, setPixValues, toastFullScreen])

    useEffect(() => {
        pixTimerRef.current = setInterval(() => {
            verifyPixPayment();
        }, 5000);

        return () => {
            if (pixTimerRef.current) {
                clearInterval(pixTimerRef.current);
            }
        }
    }, [pixTimerRef, verifyPixPayment]);

    useEffect(() => {
        verifyPixPayment();
    }, [verifyPixPayment]);

    const onClickCopy = useCallback(async() => {
        if (pixValues) {
            await window.navigator.clipboard.writeText(pixValues.qrCodeLink);
            toast("Codigo copiado com sucesso", { type: "info", delay: 200 })
        }
    }, [pixValues])

    return (
        <div className={styles.pixPage} >
            <h1>PIX</h1>
            {pixValues && <div className={styles.container} >
                <span>Leia o <strong>QRCode</strong> para efetuar o pagmento </span>
                <h2>{new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(pixValues?.value ?? 0)}</h2>
                {pixValues && <img src={`data:image/png;base64,${pixValues.qrCodeBase64}`} alt={"QRCode para pagamento"}></img>}
                <span>Ou clique em <strong>copiar chave</strong></span>
                <Button fullWidth
                        variant='contained'
                        color="primary"
                        onClick={onClickCopy}>
                    <Icon>content_copy</Icon>
                    Copiar chave
                </Button>
            </div>}
        </div>
    )
}
export default TablePixPage;